module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<i class="icon icon-rtype_i16_'+
((__t=(id))==null?'':__t)+
'"></i>\r\n<span>'+
((__t=(name))==null?'':__t)+
'</span>\r\n<div class="toursCount">'+
((__t=(count))==null?'':__t)+
'</div>';
}
return __p;
};
